export { getParent } from '@fluentui/dom-utilities';
//# sourceMappingURL=getParent.js.map